var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RecetteListe", {
        attrs: { recetteList: _vm.liste, allowMultiAction: _vm.profilIsAdmin },
        on: {
          "set-terme-de-recherche": function($event) {
            return _vm.keepTermeDeRecherche($event)
          },
          "set-categories": function($event) {
            return _vm.keepCategorieIds($event)
          },
          "set-composantes": function($event) {
            return _vm.keepComposanteIds($event)
          },
          "set-type-de-recherche": function($event) {
            return _vm.keepTypeDeRecherche($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }